import {useAppState} from "@/store";
import ProgressStep from "@/components/ProgressStep";
import TrophyIcon from "@/components/icons/TrophyIcon";
import StarIcon from "@/components/icons/StarIcon";
import ShieldIcon from "@/components/icons/ShieldIcon";
import FeesIcon from "@/components/icons/FeesIcon";

export default function ProgressBar({labels, goToStep}) {

    const {state} = useAppState()

    function HorizontalIcon({label, icon}) {
        return (
            <div className={"flex items-center font-bold text-[11px] lg:text-[14px] whitespace-nowrap"}>
                <div className={"size-[18px] lg:size-[24px] mr-[2px] lg:mr-[4px]"}>
                    {icon}
                </div>
                {label}
            </div>
        )
    }


    return (
        <div className={"fixed top-[var(--wp-admin--admin-bar--height,0px)] left-0 w-full z-[10000] lg:bg-white border-b border-inactive-grey"}>

            <div className={"lg:h-[90px] p-[16px] lg:p-0 relative bg-brand-orange lg:bg-transparent flex items-center justify-between"}>

                <div className={"lg:absolute lg:left-[32px] lg:top-[32px] text-white lg:text-brand-blue"}>
                    {state.currentStep > 1 ? (
                        <button
                            className={'ein-btn-plain text-[18px] decoration-transparent hover:decoration-brand-blue lg:hover:decoration-white transition-colors'}
                            onClick={() => goToStep(state.currentStep - 1)}
                        >
                            ← Back
                        </button>
                    ) : (
                        <button
                            className={'ein-btn-plain text-[18px] decoration-transparent hover:decoration-brand-blue lg:hover:decoration-white transition-colors'}
                            onClick={() => window.location.href = '/'}
                        >
                            ← Home
                        </button>
                    )}
                </div>

                <div className={"lg:border-b lg:border-inactive-grey lg:w-min lg:mx-auto lg:px-[32px] h-full flex items-end lg:items-center justify-end lg:justify-center"}>
                    <ul className="daisy-steps relative">
                        {labels.map((label, i) => (
                            <ProgressStep goToStep={goToStep} key={i} step={i+1} finished={state.currentStep > i+1} current={state.currentStep === i+1} label={label} />
                        ))}
                    </ul>
                </div>
            </div>
            <div className={"h-[39px] lg:h-[49px] flex items-center justify-center space-x-[16px] lg:space-x-[32px] bg-white lg:bg-transparent"}>
                <div className={"hidden lg:!block"}>
                    <HorizontalIcon icon={<TrophyIcon/>} label={'Multi-award winning'}/>
                </div>
                <HorizontalIcon icon={<StarIcon/>} label={'4.9/5 Stars'}/>
                <HorizontalIcon icon={<ShieldIcon/>} label={'$2000 Coverage'}/>
                {(!state.branch || state.branch.tripFees === 0) && (
                    <HorizontalIcon icon={<FeesIcon/>} label={'No Hidden Fees'}/>
                )}

            </div>
        </div>
    )
}
